
@switch (columnId) {
  @case (FeePlanOrderBy.Id) {
    <lib-text-table-column>
      {{ element.id }}
    </lib-text-table-column>
  }
  @case (FeePlanOrderBy.Name) {
    <lib-text-table-column>
      {{ element.name }}
    </lib-text-table-column>
  }
  @case (FeePlanOrderBy.Description) {
    <lib-text-table-column>
      {{ element.description }}
    </lib-text-table-column>
  }
  @default {
  }
}
